/* pl-cart.js — keeps every [data-cart-count] badge in sync.
   Listen: document 'pl:cart:changed' → fetch /cart.js → update badges + pulse.
   Self-initializing and idempotent (guarded by a window flag). */
(function () {
  'use strict';
  if (window.__plCartInit) return;
  window.__plCartInit = true;

  var style = document.createElement('style');
  style.textContent =
    '@keyframes pl-count-pulse{0%{transform:scale(1)}50%{transform:scale(1.35)}100%{transform:scale(1)}}' +
    '[data-cart-count].pl-pulse{animation:pl-count-pulse .35s ease}';
  document.head.appendChild(style);

  function updateBadges() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
          el.classList.remove('pl-pulse');
          void el.offsetWidth; /* restart the pulse animation */
          el.classList.add('pl-pulse');
        });
      })
      .catch(function () { /* network hiccup: keep current count */ });
  }

  document.addEventListener('pl:cart:changed', updateBadges);
})();
